import { influencerSubscriptionService } from '../services/influencerSubscriptionService';

const loadRazorpayScript = () => {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) {
      resolve(window.Razorpay);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(window.Razorpay);
    script.onerror = () => reject(new Error('Failed to load Razorpay script'));
    document.body.appendChild(script);
  });
};

/**
 * Open Razorpay subscription checkout for influencer Insta Tools plans.
 */
export const payWithInfluencerRazorpay = async ({
  planType = 'premium',
  billingCycle = 'monthly',
  planName,
  billing,
  onSuccess,
  onError,
}) => {
  try {
    const createResponse = await influencerSubscriptionService.createSubscription(
      planType,
      billingCycle,
      billing
    );
    const { subscriptionId, keyId, mode } = createResponse.data || {};

    if (!subscriptionId || !keyId) {
      throw new Error('Could not create subscription. Please try again.');
    }

    const Razorpay = await loadRazorpayScript();

    const options = {
      key: keyId,
      subscription_id: subscriptionId,
      name: 'Infuber',
      description: `Insta Tools: ${planName || planType} (${billingCycle})`,
      ...(mode === 'recovery' ? { subscription_card_change: true } : {}),
      handler: function () {
        if (onSuccess) onSuccess({ mode: mode || 'new' });
      },
      theme: { color: '#000000' },
      modal: {
        ondismiss: function () {
          if (onError) {
            onError(new Error('Payment cancelled'));
          }
        },
      },
    };

    const razorpay = new Razorpay(options);
    razorpay.open();
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      'Payment failed. Please try again.';
    if (onError) {
      onError(new Error(message));
    }
  }
};
